import type { QuoteStatus } from '../api/types'

/**
 * Canonical status → variant / label maps for quotes. Lives in its own
 * (component-free) module so both <QuoteStatusChip> and the Quotes page's
 * group-by-status logic share one source of truth without tripping the
 * react-refresh "only export components" rule.
 *
 * Seven stages: Draft / Pricing In Review / Revise Pricing / Pricing
 * Approved / Sent / Customer Approved / Customer Rejected.
 */
export const VARIANT_BY_STATUS: Record<
  QuoteStatus,
  'neutral' | 'info' | 'warning' | 'success' | 'danger'
> = {
  draft: 'neutral',
  in_review: 'warning', // active approver task
  revise_pricing: 'warning', // sales has work to do
  approved: 'success',
  sent: 'info',
  customer_approved: 'success',
  customer_rejected: 'danger',
}

export const LABEL_BY_STATUS: Record<QuoteStatus, string> = {
  draft: 'Draft',
  in_review: 'Pricing In Review',
  revise_pricing: 'Revise Pricing',
  approved: 'Pricing Approved',
  sent: 'Sent',
  customer_approved: 'Customer Approved',
  customer_rejected: 'Customer Rejected',
}
